import { useEffect, useRef, useState } from "react";
import TaskModal from "../common/modal/TaskModal";
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";
import { httpReauest } from "../../utils/httpRequest";

// دیتای پیش‌فرض قسمت 1 (در صورت fallback)
import defaultStageData from "../../data/episode1.js";
import { ArrowLeft } from "iconsax-reactjs";
import TaskViewModal from "../common/modal/TaskViewModal.jsx";

export default function GameMap({ user, episode = 1, setSelectedEpisode }) {
  const { t } = useTranslation();
  const ref = useRef();

  const [stages, setStages] = useState(defaultStageData.stages);
  const [animationData, setAnimationData] = useState(
    defaultStageData.animationData
  );
  const [mapImage, setMapImage] = useState(defaultStageData.mapImage);

  const [viewTask, setViewTask] = useState(null);

  const [currentStage, setCurrentStage] = useState(
    user.game.episode > episode ? 20 : user.game.level
  );
  const [isLoading, setisLoading] = useState(user.game.isLoading);
  const [nextStep, setnextStep] = useState(user.game.nextStep);
  // const [nextStep, setnextStep] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const character = stages[Math.min(currentStage, stages.length - 1)];

  // بارگذاری دیتا بر اساس episode
  useEffect(() => {
    const loadEpisodeData = async () => {
      try {
        const data = await import(`../../data/episode${episode}.js`);
        setStages(data.stages);
        setAnimationData(data.animationData);
        setMapImage(data.mapImage);
      } catch (err) {
        console.warn("دیتای قسمت مورد نظر پیدا نشد. استفاده از دیتا پیش‌فرض.");
      }
    };
    loadEpisodeData();
  }, [episode]);

  useEffect(() => {
    if (currentStage < 20) {
      ref.current.scrollTo({
        left: stages[currentStage].x - 150,
        behavior: "smooth",
      });
    } else {
      ref.current.scrollTo({
        left: stages[19].x - 150,
        behavior: "smooth",
      });
    }

    if (nextStep) {
      setisLoading(false);
      setTimeout(() => {
        setCurrentStage(currentStage + 1);
        handleGoingNextStep();
      }, 500);
    }
  }, []);

  const handleStartClick = () => {
    if (!isLoading) {
      setIsModalOpen(true);
    }
  };

  async function handleGoingNextStep() {
    await httpReauest("POST", "/game/done/nextstep", { episode }, {}).then(
      () => {
        if (currentStage + 1 > 19) {
          setTimeout(() => {
            window.location.reload();
          }, 200);
        }
      }
    );
  }

  return (
    <div
      ref={ref}
      dir="ltr"
      id="game-map"
      className="overflow-auto flex relative min-h-screen"
    >
      <span className="relative">
        <img
          src={mapImage}
          className="h-full object-cover min-w-[1888px] max-w-[1888px] min-h-[722px] max-h-[722px]"
          alt="Sambite Game Map"
        />

        {/* شخصیت کاربر */}
        <img
          src={isLoading ? "/character-loading.png" : "/character.png"}
          className="w-28 absolute z-[42] transition-all duration-1000"
          style={{
            left: `${character?.x - 20}px`,
            top: `${character?.y - 50}px`,
          }}
          alt="Sambite Character"
        />

        {/* انیمیشن‌ها */}
        {animationData.map((ani, i) => {
          if (ani.type === "lottie") {
            return (
              <Lottie
                key={i}
                animationData={ani.data}
                loop={true}
                className="z-30 absolute"
                style={{
                  left: `${ani.x}px`,
                  top: `${ani.y}px`,
                  width: ani.width,
                }}
              />
            );
          } else {
            return (
              <img
                key={i}
                src={ani.data}
                alt="Map Item"
                className="z-30 absolute"
                style={{
                  left: `${ani.x}px`,
                  top: `${ani.y}px`,
                  width: ani.width,
                }}
              />
            );
          }
        })}

        {/* مراحل */}
        {stages.map((stage, index) => (
          <button
            disabled={index > currentStage}
            onClick={async () => {
              if (index < currentStage) {
                const user = JSON.parse(localStorage.getItem("user"));
                try {
                  const res = await httpReauest(
                    "GET",
                    `/task/submission/${user._id}/${episode}/${index}`,
                    {},
                    { "x-access-token": user.token }
                  );
                  setViewTask(res.data.data);
                } catch (err) {
                  console.error("Failed to load task data", err);
                }
              }
            }}
            key={index}
            className={`w-16 h-16 rounded-full absolute z-40 flex items-center justify-center text-white text-[24px] font-bold shadow-lg hover:scale-110 transition-transform duration-300 ${
              index < currentStage ? "bg-green-600" : ""
            }`}
            style={{
              left: `${stage.x}px`,
              top: `${stage.y}px`,
              background:
                index < currentStage
                  ? "green"
                  : "radial-gradient(circle at 30% 30%, rgb(210, 180, 140), rgb(115 111 107))",
              border: "2px solid rgb(109 105 101)",
              boxShadow: "rgba(0, 0, 0, 0.4) 1px 0px 11px 9px",
            }}
          >
            {index + 1}
          </button>
        ))}
      </span>

      {/* دکمه شروع */}
      {currentStage < 21 && (
        <button
          onClick={handleStartClick}
          className="fixed bottom-24 left-1/2 -translate-x-1/2 bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-xl shadow-lg text-xl z-50"
        >
          {isLoading ? t("game_waiting_approval") : t("game_start")}
        </button>
      )}

      <button
        onClick={() => setSelectedEpisode(null)}
        className="fixed top-4 left-3 z-50 text-white bg-orange-600 rounded-full p-1"
      >
        <ArrowLeft size={26} />
      </button>

      {viewTask && (
        <TaskViewModal task={viewTask} onClose={() => setViewTask(null)} />
      )}

      {/* مودال */}
      {isModalOpen && (
        <TaskModal
          setIsModalOpen={setIsModalOpen}
          currentStage={currentStage}
          stages={stages}
          setCurrentStage={setCurrentStage}
          setisLoading={setisLoading}
        />
      )}
    </div>
  );
}
